module.exports = __webpack_public_path__ + "static/media/A.f7975461.png";


//////////////////
// WEBPACK FOOTER
// ./src/mobioastro/assets/images/A.png
// module id = 150
// module chunks = 0